import React from 'react';
import { Separator, Spinner, TSeparatorSpacing } from 'telia-front-react';

interface SpinnerWithSpacingProps {
  spacing?: TSeparatorSpacing;
}

const SpinnerWithSpacing: React.FC<SpinnerWithSpacingProps> = ({ spacing = 'small' }) => {
  return (
    <>
      <Separator spacing={spacing} color="invisible" />
      <Spinner />
    </>
  );
};

export default SpinnerWithSpacing;
